window.coolHelperFunctions = {

  slideUp(target, new_duration){
    const duration = new_duration || 500
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.clientHeight + 'px';
    target.clientHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration + 1);
  },

  slideDown(target, new_duration){
    const duration = new_duration || 500
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.clientHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.clientHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration + 1);
  },

  /**
   * Generates an ID
   */
  generateID(){
    return `_${Math.random().toString(36).substr(2, 9)}`
  },

  /**
   * Wraps an element
   * @param el | DOM element
   */
  wrap(el, wrapperTag, namespace = "") {
    let wrapper
    if(namespace){
      wrapper = document.createElementNS(namespace, wrapperTag)
    } else {
      wrapper = document.createElement( wrapperTag ? wrapperTag : 'div')  
    }
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
    return wrapper
  },

  prefersReducedMotion(){
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    return !!isReduced
  },
  
  getCookie(cname) {
    var name = cname + "="
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  },
  
  setCookie(cname, cvalue, exdays) {
    var d = new Date()
    d.setTime(d.getTime() + (exdays*24*60*60*1000))
    var expires = "expires="+ d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
  },

  cleanExpiredLocalStorage() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const itemStr = localStorage.getItem(key);
      if (!itemStr) continue;

      try {
        const item = JSON.parse(itemStr);
        if (item.expiry && Date.now() > item.expiry) {
          localStorage.removeItem(key);
        }
      } catch (e) {
        continue; // Skip invalid JSON entries
      }
    }
  },

  setTemporaryLocalStorage(key, value, expiresIn, unit = 'seconds') {
    const now = Date.now();
    const unitMultipliers = {
      seconds: 1000,
      minutes: 60000,
      hours: 3600000,
      days: 86400000
    };

    const ttl = (unitMultipliers[unit] || 1000) * expiresIn;
    localStorage.setItem(key, JSON.stringify({ value, expiry: now + ttl }));
  },

  getTemporaryLocalStorage(key) {
    this.cleanExpiredLocalStorage()

    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  },

  setTemporarySessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify({ value }))
  },
  
  getTemporarySessionStorage(key) {
    const itemStr = sessionStorage.getItem(key)
    if(!itemStr) return null
    const item = JSON.parse(itemStr)
    return item.value
  },
  

  tryToFocusFirstChildOf(parentNode){
    const focusableElements = parentNode.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    if(focusableElements){
      focusableElements.focus()
    }
  },

  debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  },

  // //gets a GET string from the URL
  getURLParam(key){
    var params = {}
    var parser = document.createElement('a')
    parser.href = window.location.href
    var query = parser.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      params[pair[0]] = decodeURIComponent(pair[1])
    }

    return typeof params[key] !== undefined ? params[key] : null
  },

  coolAjax(postData, successCB, errorCB){
    jQuery.ajax({
      url: window.coolfse.ajaxUrl, //localized variable
      method: "POST",
      data: postData,
      complete: data => {
        if(data.status == 200){
          if(data?.responseJSON){
            successCB(data.responseJSON)
          } else {
            errorCB(`Please try again later. Error: no response json. `)
          }
        } else {
          errorCB(`Please try again later. Error code: ${data.status}.`)
        }
      }
    })
  }
}


// //check if an element is visible
// function isVisible(el){
//   return el.offsetParent !== null 
// }

// function isInViewport(element) {
//     const rect = element.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//     );
// }

// /**
//  * Get all parts of a date
//  * Example usage: 
//  * const parts = getDateParts(new Date())
//  * console.log(parts)
//  **/
// function getDateParts(d){
//   function isValidDate(date) {
//     return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
//   }

//   function zerofill(number, length) {
//     // Setup
//     var result = number.toString();
//     var pad = length - result.length;

//     while(pad > 0) {
//       result = '0' + result;
//       pad--;
//     }

//     return result;
//   }

//   if(!isValidDate(d)){
//     console.error("Invalid date passed to getDateParts")
//     return {}
//   }

//   let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
//   let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//   let day = d.getDay();
//   let hour = d.getHours();
//   let minute = d.getMinutes();
//   if (minute < 10) {
//       minute = "0" + minute;
//   }
//   let second = zerofill(d.getSeconds(), 2)
//   let ampm = "am";
//   if( hour >= 12 ) {
//       hour -= 12;
//       if(hour == 0){
//         hour = 12
//       }
//       ampm = "pm";
//   }
//   let date = d.getDate();
//   let month = d.getMonth();
//   let year = d.getFullYear();

//   let dayName = days[day]
//   let monthName = months[month]

//   return {
//     day, hour, minute, second, ampm, date, month, year, dayName, monthName
//   }
// }

// /**
//  * Change's an element's tagName to something else (div => button or whatever)
//  */
// function replaceTag(element, newTag){
//   let newEl = document.createElement(newTag)
//   cloneAttributes(newEl, element)

//   // move all elements in the other container.
//   while(element.firstChild) {
//       newEl.appendChild(element.firstChild);
//   }
//   element.parentNode.replaceChild(newEl,element)

//   return newEl
// }

// /**
//  * clones all attributes from one element to another
//  */
// function cloneAttributes(target, source) {
//   [...source.attributes].forEach( attr => { target.setAttribute(attr.nodeName ,attr.nodeValue) })
// }

// function insertAfter(newNode, existingNode) {
//   existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
// }